
import Vue from 'vue'
import moment from 'moment'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const prospectModule = namespace('prospect')
const alerteModule = namespace('alerte')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectAlerte extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @alerteModule.Action('deleteAlerteAction') deleteAlerte: any

  getAlerteClassDateTime(date) {
    return moment(date).isBefore(moment()) ? 'text-red' : ''
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm("Confirmez vous la suppression de l'alerte ?", optionsVslim)
    if (ok) {
      this.deleteAlerte(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }
}
